import React, {useEffect} from 'react';

import '../../../App.css';
import {Button, Layout, Menu, Modal} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBolt, faCompactDisc, faGear, faUsers} from "@fortawesome/free-solid-svg-icons";
import ProjectGeneralSettings from "./ProjectGeneralSettings";
import ProjectMembersSettings from "./ProjectMembersSettings";
import Sider from "antd/es/layout/Sider";
import {Content} from "antd/es/layout/layout";
import {ProjectAiSettings} from "./ProjectAiSettings";
import {ProjectStorageSettings} from "./ProjectStorageSettings";
import {useAppDispatch, useAppSelector} from "../../../feature/tools";
import {closeProjectSettings} from "../../../feature/project/appSettingsSlice";

export const ProjectSettings = (
    props: {
        saveFunction: (saveFunction: () => void) => void
    }
) => {
    const projectSettings = useAppSelector(state => state.appSettingsSlice.projectSettings)
    const [category, setCategory] = React.useState(projectSettings)

    useEffect(() => {
        setCategory(projectSettings)
    }, [projectSettings]);

    return (
        <Layout style={{maxHeight: 800, minHeight: 600, overflow: 'hidden'}}>
            <Sider width={200}>
                <Menu
                    defaultSelectedKeys={[category as string]}
                    selectedKeys={[category as string]}
                    mode="inline"
                    style={{height: '100%', borderInlineEnd: '0'}}
                    items={[
                        {
                            key: 'general',
                            label: 'General',
                            icon: <FontAwesomeIcon icon={faGear}/>
                        },
                        {
                            key: 'members',
                            label: 'Members',
                            icon: <FontAwesomeIcon icon={faUsers}/>
                        },
                        {
                            key: 'ai',
                            label: 'AI Providers',
                            icon: <FontAwesomeIcon icon={faBolt}/>
                        },
                        {
                            key: 'storage',
                            label: 'Storage Provider',
                            icon: <FontAwesomeIcon icon={faCompactDisc}/>
                        }
                    ]}
                    onClick={(item) => {
                        //@ts-ignore
                        setCategory(item.key)
                    }}
                />
            </Sider>
            <Content style={{padding: '0 0 0 20px ', overflowY: 'auto', minWidth: 600, background: "#fff"}}>
                {category === 'general' ?
                    <ProjectGeneralSettings saveFunction={(saveFunction) => props.saveFunction(saveFunction)}/> : ''}
                {category === 'members' ?
                    <ProjectMembersSettings saveFunction={(saveFunction) => props.saveFunction(saveFunction)}/> : ''}
                {category === 'ai' ?
                    <ProjectAiSettings saveFunction={(saveFunction) => props.saveFunction(saveFunction)}/> : ''}
                {category === 'storage' ?
                    <ProjectStorageSettings saveFunction={(saveFunction) => props.saveFunction(saveFunction)}/> : ''}
            </Content>
        </Layout>
    )
        ;
};

export const ProjectSettingsModal = () => {
    const dispatch = useAppDispatch()
    const projectSettings = useAppSelector(state => state.appSettingsSlice.projectSettings)
    const [saveFunction, setSaveFunction] = React.useState<{ fn: () => void } | undefined>(undefined)

    return (
        <Modal
            zIndex={projectSettings == 'ai' || projectSettings == 'storage' ? 10000 : 0}
            open={projectSettings != undefined}
            okText={'Save'}
            onOk={() => {
                if (saveFunction) {
                    saveFunction.fn()
                }
            }}
            onCancel={() => dispatch(closeProjectSettings())}
            cancelText={'Close'}
            title={'Project Settings'}
            width={1000}
            footer={[
                <Button key="back" onClick={() => dispatch(closeProjectSettings())}>
                    Close
                </Button>,
                <Button key="submit" type="primary" onClick={() => {
                    if (saveFunction) {
                        saveFunction.fn()
                    }
                }}>
                    Save
                </Button>,
                <Button
                    key="save_and_close"
                    type="primary"
                    onClick={() => {
                        if (saveFunction) {
                            saveFunction.fn()
                        }
                        dispatch(closeProjectSettings())
                    }}
                >
                    Save and Close
                </Button>,
            ]}
        >
            <ProjectSettings saveFunction={(sFunction) => setSaveFunction({fn: sFunction})}/>
        </Modal>
    )
}